import { Icon, IconArrowLeft, IconArrowRight } from "@flixbus/honeycomb-icons-react";
import { Button } from "@flixbus/honeycomb-react";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import calculatePagerPageNumber from "../../helper/calculatePagerPageNumber/calculatePagerPageNumber";
import { SelectOption } from "../../helper/reactSelect/types";
import PagerSkeleton from "../pagerSkeleton/PagerSkeleton";
import Select from "../select/Select";
import * as css from "./Pager.scss";
import filterOptions from "./filterOptions/filterOptions";

export type PagerProps = {
  loading: boolean;
  onChange: (page: number, pageSizeName: string) => void;
  pageSizeOptions: SelectOption[];
  isDropUp: boolean;
  currentPage?: number;
  totalItems?: number;
  pageSize: {
    name: string;
    value: number;
  };
};

const Pager: React.FC<PagerProps> = ({
  loading,
  onChange = () => {},
  pageSizeOptions,
  isDropUp,
  currentPage,
  totalItems = 0,
  pageSize,
}) => {
  const avialableOptions = filterOptions(pageSizeOptions, totalItems);
  const totalPages = totalItems ? calculatePagerPageNumber(totalItems, pageSize.value) : undefined;
  const disableNext = currentPage !== undefined && totalPages !== undefined ? currentPage + 1 >= totalPages : true;
  const disablePrevious = currentPage !== undefined ? currentPage <= 0 : true;

  if (loading) {
    return <PagerSkeleton />;
  } else {
    return (
      <div className={css.wrapper}>
        <div className={css.select}>
          <Select
            options={avialableOptions}
            initialValue={pageSizeOptions.find((option) => option.value === pageSize.name)}
            onSelect={({ value }) => onChange(0, value)}
            isDisabled={avialableOptions.length <= 1}
            isDropUp={isDropUp}
          />
        </div>
        <div className={css.dropdownLabel}>
          <FormattedMessage id="pager.dropdown.label" values={{ totalItems }} />
        </div>
        <Button
          display="square"
          aria-label="Go Back"
          disabled={disablePrevious}
          onClick={() => onChange(currentPage! - 1, pageSize.name)}
        >
          <Icon InlineIcon={IconArrowLeft} aria-hidden="true" />
        </Button>
        <span>
          <FormattedMessage
            data-id="page-label"
            id="pager.page.label"
            values={{
              b: (msg) => <b>{msg}</b>,
              currentPage: currentPage! + 1,
              totalPages,
            }}
          />
        </span>
        <Button
          display="square"
          aria-label="Go Forward"
          disabled={disableNext}
          onClick={() => onChange(currentPage! + 1, pageSize.name)}
        >
          <Icon InlineIcon={IconArrowRight} aria-hidden="true" />
        </Button>
      </div>
    );
  }
};

export default Pager;
